<template>
  <div>
    <div class="d-flex flex-column h-100" data-test="sidebar-project">
      <div class="pt-3 pl-3 text-left">
        <img src="@/assets/logo/logo.svg" height="35" />
      </div>

      <div class="d-flex flex-column h-100 overflow-y-scroll">
        <div v-if="projectId">
          <div class="mt-50 pt-3 pb-3 pl-2 pr-2">
            <sidebar-category name="Créer" @click="goToTaskWizardMobile" />
            <!-- <sidebar-category-dropdown name="Créer" @create-folder="handleFolder" @create-chat="goToTaskWizardMobile" /> -->

            <!-- <sidebar-category
              @click="goToTaskWizardMobile"
              :name="'New' | __t('projects__tasks__headline__new')"
              class="mt-3 mb-3"
            /> -->

            <!-- <h6 class="mt-4 w-100 text-uppercase text-light font-poppins">
              Folders
            </h6>

            <div>
              <p class="ml-2">
                <small class="text-muted">
                  {{ "You don't have any folder yet." | __t("projects__tasks__you-dont-have-any-task-yet") }}
                </small>
              </p>
            </div> -->

            <h6 class="mt-4 w-100 text-uppercase text-light font-poppins">
              Recents
            </h6>

            <sidebar-task
              v-for="t in openTasks()"
              @go-to="goToTask(t)"
              :key="t.id"
              :name="t.name"
              :is-active="t.id === taskId"
              :params="{ taskId: t.id }"
              :project-id="projectId"
              :task-id="t.id"
              to="ProjectTask"
              class="mb-1 w-100"
              icon="check"
            />

            <div v-if="!openTasks().length">
              <p class="ml-2">
                <small class="text-muted">
                  {{ "You don't have any chat yet." | __t("projects__tasks__you-dont-have-any-chat-yet") }}
                </small>
              </p>
            </div>
          </div>

          <!-- TODO: This should be at the bottom of the screen -->
          <div class="mt-auto">
            <div class="ml-2 mr-2">
              <!-- <h6 class="mt-4 w-100 text-uppercase text-light font-poppins">
              Team
            </h6> -->

              <div v-for="i in NAVIGATION" :key="i.id">
                <sidebar-item
                  :name="i.name"
                  :icon="i.icon"
                  :color="i.color"
                  :is-active="i.to === routeName || (i.container && routePath.includes(i.container))"
                  @click="goTo(i.to)"
                />
              </div>
            </div>

            <sidebar-projects-list />

            <!-- <div class="m-2 p-2 text-center bg-black rounded">
              <span class="font-weight-bold text-white">
                {{ projectName }}
              </span>

              <img src="@/assets/icons/chevron-down.svg" width="15" height="15" />
            </div> -->

            <spacer v-if="NODE_ENV === 'development'" height="25px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { FETCH, CREATE, LISTEN, UPDATE } from "@/store/actions";

import { NAVIGATION } from "@/constants/project";
import { PLANS } from "@/constants/billing";
import { DOCUMENTS_TYPES } from "@/constants/documents";

import Spacer from "@/components/Layouts/Spacer";

import SidebarProjectsList from "./ProjectsList";
import SidebarCategory from "./Category";
import SidebarItem from "./Item";
import SidebarTask from "./Task";

export default {
  name: "ProjectSidebar",
  components: { SidebarProjectsList, SidebarCategory, SidebarItem, SidebarTask, Spacer },
  computed: {
    ...mapState({ projects: (state) => state.projects.items }),
    ...mapGetters("projectsDocuments", ["tree"]),
    ...mapGetters("projectsTasks", ["openTasks"]),
    projectId() {
      return this.$route.params.projectId;
    },
    projectName() {
      const { projectId } = this;
      return this.projects[projectId]?.name;
    },
    taskId() {
      return this.$route.params.taskId;
    },
    routeName() {
      return this.$route.name;
    },
    isMobile() {
      const { value } = this.$screen.alias;
      return value === "xs" || value === "sm" || value === "md";
    },
  },
  data() {
    return {
      currentFileId: null,
      localTree: [],

      currentlyHighlighted: null,

      isLoading: true,

      NODE_ENV: process.env.NODE_ENV,
      NAVIGATION,
      PLANS,
    };
  },
  watch: {
    tree: {
      handler() {
        this.localTree = JSON.parse(JSON.stringify(this.tree));
      },
      deep: true,
    },
  },
  mounted() {
    const { projectId } = this;

    if (projectId) this.init();
  },
  methods: {
    ...mapActions("projectsDocuments", {
      fetchDocuments: FETCH,
      listenDocuments: LISTEN,
      createDocument: CREATE,
      updateDocument: UPDATE,
    }),
    ...mapActions("projectsTasks", { fetchTasks: FETCH, listenTasks: LISTEN }),
    async init() {
      this.isLoading = true;

      const { projectId } = this;

      await this.fetchDocuments({ projectId });
      await this.listenDocuments({ projectId });

      await this.fetchTasks({ projectId });
      await this.listenTasks({ projectId });

      const { createTask } = this.$route.query;

      if (createTask) this.$router.push({ name: "ProjectTaskWizard" });
      this.isLoading = false;
      this.localTree = JSON.parse(JSON.stringify(this.tree));
    },

    async triggerCreateDocumentFolder() {
      this.isSending = true;

      const { projectId } = this;
      const type = DOCUMENTS_TYPES.FOLDER;
      const { id: documentId } = await this.createDocument({ projectId, type });

      this.$router.push({ name: "ProjectDocument", params: { documentId } });

      this.isSending = false;
    },

    onStart(event) {
      event.stopPropagation();
      this.drag = true;
    },

    onEnd(event) {
      event.stopPropagation();
      this.drag = false;
      this.triggerUpdateDocument(event);

      this.currentlyHighlighted.style.backgroundColor = "unset";
      this.currentlyHighlighted = null;
    },

    onMove(event) {
      if (this.currentlyHighlighted) {
        this.currentlyHighlighted.style.backgroundColor = "unset"; // Reset background color
      }

      this.currentlyHighlighted = event.related;
      this.currentlyHighlighted.style.backgroundColor = "rgba(0, 0, 0, 0.1)";

      return true;
    },

    triggerUpdateDocument(event) {
      const { projectId } = this;

      let movedElement = event.item.querySelector("[data-id]");
      let movedElementId = movedElement.getAttribute("data-id");

      let newParentEl = event.to.previousSibling;

      let newParentId = newParentEl ? newParentEl.getAttribute("data-id") : null;
      const newIndex = event.newIndex;

      this.updateDocument({
        projectId,
        id: movedElementId,
        parentId: newParentId,
        position: newIndex,
      });
    },

    goToTaskWizardMobile() {
      const { isShowingSidebar, isMobile } = this;
      const { name: routeName } = this.$route;

      if (!isMobile) {
        this.$router.push({ name: "ProjectTaskWizard" });
        return;
      }

      if (routeName === "ProjectTaskWizard") {
        this.$emit("update:is-showing-sidebar", !isShowingSidebar);
        return;
      }

      this.$router.push({ name: "ProjectTaskWizard" });
    },
    goToTask({ id: taskId }) {
      const { isShowingSidebar, isMobile } = this;
      const { name: routeName } = this.$route;
      const { taskId: currentTaskId } = this.$route.params;

      if (!isMobile) {
        this.$router.push({ name: "ProjectTask", params: { taskId } });
        return;
      }

      if (routeName === "ProjectTask" && currentTaskId === taskId) {
        this.$emit("update:is-showing-sidebar", !isShowingSidebar);
        return;
      }

      this.$router.push({ name: "ProjectTask", params: { taskId } });
    },
    goTo(routeName) {
      const { isMobile } = this;
      const { name: currentRouteName } = this.$route;

      if (!isMobile) {
        this.$router.push({ name: routeName });
        return;
      }

      if (currentRouteName === routeName) {
        this.$emit("update:is-showing-sidebar", false);
        return;
      }

      this.$router.push({ name: routeName });
    },
    handleFolder() {},
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_settings";

.list-change-enter-active,
.list-change-leave-active {
  transition: opacity 0.5s;
}
.list-change-enter,
.list-change-leave-to {
  opacity: 0;
}
</style>
